const HOUR_MS = 60 * 60 * 1000

const MAX_INTERP_GAP_MS = 1.5 * HOUR_MS

const LEADS_TO_LATER_FRAME = 0.5

export const bracket = (framesMs: number[], targetMs: number) => {
    let before = -1
    let after = -1
    for (let i = 0; i < framesMs.length; i++) {
        if (framesMs[i] <= targetMs) before = i
        if (framesMs[i] >= targetMs && after === -1) after = i
    }
    return { before, after }
}

export const displayedFrameIndex = (framesMs: number[], targetMs: number) => {
    const { before, after } = bracket(framesMs, targetMs)
    if (before === -1 || after === -1) return null
    if (before === after) return before
    if (framesMs[after] - framesMs[before] > MAX_INTERP_GAP_MS) return null
    const weight = (targetMs - framesMs[before]) / (framesMs[after] - framesMs[before])
    return weight < LEADS_TO_LATER_FRAME ? before : after
}

export const displayedFrameTime = (framesMs: number[], targetMs: number) => {
    const idx = displayedFrameIndex(framesMs, targetMs)
    return idx === null ? null : new Date(framesMs[idx]).toISOString()
}

type RenderableSpan = [startMs: number, endMs: number]

export const renderableSpans = (framesMs: number[]) => {
    const spans: RenderableSpan[] = []
    for (let i = 0; i < framesMs.length; i++) {
        const startMs = framesMs[i]
        while (i + 1 < framesMs.length && framesMs[i + 1] - framesMs[i] <= MAX_INTERP_GAP_MS) i++
        spans.push([startMs, framesMs[i]])
    }
    return spans
}

export const spanCovers = (spans: RenderableSpan[], targetMs: number) => {
    let low = 0
    let high = spans.length - 1
    while (low <= high) {
        const mid = (low + high) >> 1
        if (targetMs < spans[mid][0]) high = mid - 1
        else if (targetMs > spans[mid][1]) low = mid + 1
        else return true
    }
    return false
}
